export default function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-white flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className="text-4xl font-black" style={{ color: '#6F9A41' }}>bubbala</h1>
          <p className="mt-2 text-gray-600">Send a Monthly Hug to Grandma</p>
        </div>

        {title && (
          <div className="mt-8 text-center">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            {subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>}
          </div>
        )}
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-xl sm:px-10 border border-gray-100">
          {children}
        </div>
      </div>

      <div className="mt-8 text-center text-sm text-gray-500">
        <p>Keeping families connected, one story at a time.</p>
      </div>
    </div>
  );
}
